import { type Expect } from '@type-challenges/utils';
import { cx } from 'cva';
import { type FunctionComponent } from 'react';
import { type PickDeep } from 'type-fest';
import { RouterLink } from '../../../atoms/RouterLink/RouterLink';
import { MEMBER_CONTACT_US_URL } from '../../../constants';
import {
  type RootState,
  type StrictSubsetOfRootState,
} from '../../../core/root.state';
import { useSelector } from '../../../hooks/useSelector';
import { useTranslation } from '../../../i18n/resources';
import { AppRoute } from '../../../routes';
import { MediShareLogo } from '../../MediShareLogo/MediShareLogo';
import styles from './DesktopMenu.module.css';

export type DesktopMenuProps = {
  className?: string;
  failSafe?: boolean;
};

export type DesktopMenuState = PickDeep<RootState, 'auth.loggedIn'>;

type CheckState = Expect<StrictSubsetOfRootState<DesktopMenuState>>;

export const DesktopMenu: FunctionComponent<DesktopMenuProps> = ({
  className,
  failSafe = false,
}) => {
  const loggedIn = useSelector(
    (state: DesktopMenuState) => state.auth.loggedIn,
  );
  const { t } = useTranslation();

  return (
    <div className={cx(styles.root, className)}>
      <div className={styles.topMenu}>
        <div className={styles.toolbar}>
          <div className={styles.logo}>
            {!failSafe && (
              <RouterLink to={AppRoute['/chat']}>
                <MediShareLogo height={50} width={190} />
              </RouterLink>
            )}
            {failSafe && (
              <a href={AppRoute['/chat']}>
                <MediShareLogo height={50} width={190} />
              </a>
            )}
          </div>
          <div className={styles.links}>
            {!failSafe && (
              <div className={styles.centralMenu}>
                <a className={styles.menuItem} href={MEMBER_CONTACT_US_URL}>
                  {t('common', 'contact')}
                </a>
              </div>
            )}
            {loggedIn && (
              <div className={styles.centralMenu}>
                <a className={styles.menuItem} href={AppRoute['/logout']}>
                  {t('common', 'log_out')}
                </a>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};
